module.exports = __webpack_public_path__ + "images/usermodule/02.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/02.gif
// module id = 1570
// module chunks = 4